import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DashboardV2BannerComponent } from './dashboard-v2-banner/dashboard-v2-banner.component';
import { DashboardV2SlidesComponent } from '../dashboard-v2-slides/dashboard-v2-slides.component';

@Component({
  selector: 'mnf-dashboard-v2-no-investors',
  standalone: true,
  imports: [CommonModule, DashboardV2BannerComponent, DashboardV2SlidesComponent],
  templateUrl: './dashboard-v2-no-investors.component.html',
  styleUrl: './dashboard-v2-no-investors.component.scss'
})
export class DashboardV2NoInvestorsComponent {
  @Input() step!: number;
  @Input() status!: { 
    isLead: boolean; 
    isInvestor: boolean; 
    isNotInvestor: boolean; 
    isFullGrowthLead: boolean; 
    isFullDomLead: boolean; 
    isFullLead: boolean; 
  };

  bannerDashboard = [
    { title: 'Recuerda terminar tu registro', description: 'Tu dinero crecerá al 16% anual promedio, ¡Así es invertir al estilo Monific! .', button: 'Terminar mi registro', image: 'https://static.monific.com/assets/assets-app/img/banners/finish-register.png', routerLink: 'register' },
    { title: '¡Ya tienes cuenta en Monific!', description: 'Tu dinero crecerá al <span class="fw-sbold cl-primary">16% </span>anual promedio, ¡Así es invertir al estilo Monific!.', button: 'Hacer mi primera inversión', image: 'https://static.monific.com/assets/assets-app/img/banners/banner_user_with_account.svg', routerLink: 'mis-inversiones' },
  ]

}
